import { useState } from "react";
import { Moon, Sun } from "lucide-react";
import { Button } from "../components/ui/button";

export const initTheme = () => {
  if (localStorage.getItem("lw.theme") === "dark") document.documentElement.classList.add("dark");
};

export const ThemeToggle = () => {
  const [dark, setDark] = useState(() => document.documentElement.classList.contains("dark"));
  const toggle = () => {
    const d = !dark;
    setDark(d);
    document.documentElement.classList.toggle("dark", d);
    localStorage.setItem("lw.theme", d ? "dark" : "light");
  };
  return (
    <Button variant="outline" size="icon" onClick={toggle} data-testid="theme-toggle-btn"
      aria-label={dark ? "Switch to day theme" : "Switch to night theme"} title={dark ? "Day theme" : "Night theme"}
      className="h-9 w-9 rounded-full">
      {dark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </Button>
  );
};
